import AppConfig from '@/modules/core/client/app/config';

import '@/modules/core/client/core.client.module';

AppConfig.registerModule('guest', ['core']);
AppConfig.registerModule('trips', ['core']);

// config
require('@/modules/hosting/client/config/hosting.client.routes');
